import { DocumentModel } from '../model/documentsEntityModels';
import DocumentsEntity from './documentsEntity';

const DocumentsEntityListValueObject = (list: DocumentModel[]) => {
  return Object.freeze({ list: list.map((item) => DocumentsEntity(item)) });
};

export default DocumentsEntityListValueObject;
